import rafWrapper from 'raf';
export const isProduction = process.env.NODE_ENV === 'production';
export const isDevel = process.env.NODE_ENV === 'development';
export const sleep = (ms) => typeof ms === 'number'
    ? new Promise(resolve => {
        setTimeout(resolve, ms);
    })
    : Promise.resolve();
export const raf = () => new Promise(resolve => {
    rafWrapper(() => resolve());
});
export const getURLRegEx = () => /(?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
export const getColorScheme = () => {
    let detectedSystemScheme = 'light';
    if (window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches) {
        detectedSystemScheme = 'dark';
    }
    return detectedSystemScheme;
};
export const getMarkersAlias = (markers) => {
    if (!markers || !markers.length) {
        return undefined;
    }
    const { alias } = markers[0];
    return markers.every(item => item.alias === alias)
        ? alias
        : undefined;
};
export const getMarkersProperty = (markers, property) => {
    var _a, _b;
    if (!markers || !markers.length) {
        return undefined;
    }
    const value = (_a = markers[0]) === null || _a === void 0 ? void 0 : _a[property];
    for (let index = 1; index < markers.length; index += 1) {
        const valueAt = (_b = markers[index]) === null || _b === void 0 ? void 0 : _b[property];
        if (value !== valueAt) {
            return undefined;
        }
    }
    return value;
};
export const getPerpendicularDirection = (direction) => direction === 'row' ? 'column' : 'row';
export const getDirectionDivider = (direction) => direction === 'row' ? 'vertical' : 'horizontal';
export const query = (name) => {
    const parsedUrl = new URL(window.location.href);
    return parsedUrl.searchParams.get(name);
};
